import type { Resolvers } from 'owa-graph-schema';
import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyImport } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule(
    () => import(/* webpackChunkName: "DataWorkerOfflineResolvers" */ './lazyFunctions'),
    { name: 'DataWorkerOfflineResolvers' }
);

export const lazyOfflineResolvers: LazyImport<
    Promise<Resolvers>,
    LazyBootModule<typeof lazyFunctions>
> = new LazyImport(lazyModule, m => m.lazyOfflineResolvers.import());
